import { IBuildingsHasPhotos, IListingPhotos, ISuitesHasPhotos } from '@llws/lift-entity-interfaces';
import app from '@/main';

export const getNewBuildingsHasPhotos = (listingPhoto: IListingPhotos, orderBy: number): IBuildingsHasPhotos => ({
  orderBy,
  listingPhoto,
  listingPhotoId: listingPhoto.id!,
  buildingId: listingPhoto.buildingId,
  created: new Date(),
  createdUserId: parseInt(app()?.$rsGlobals.$currentUser.userId || '0', 10),
});
